import { CSSProperties } from 'react'

export const mapContainerStyle: CSSProperties = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
}

export const initialViewState = {
  longitude: 15.4404,
  latitude: 49.8238,
  zoom: 6,
  bearing: 0,
  pitch: 0,
}

export const subjectPaint = {
  'circle-radius': 6,
  'circle-color': '#53afb0',
  'circle-stroke-width': 2,
  'circle-stroke-color': '#ffffff',
}

export const subjectPaintHiglighted = {
  'circle-radius': 7.5,
  'circle-color': '#ffc300',
  'circle-stroke-width': 2,
  'circle-stroke-color': '#8f750e',
}
